import { render, staticRenderFns } from "./SpyderIcon.vue?vue&type=template&id=6b6584be&scoped=true"
import script from "./SpyderIcon.vue?vue&type=script&lang=js"
export * from "./SpyderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6584be",
  null
  
)

export default component.exports